// Copyright (c) 2025 Murr (https://github.com/vtstv)
// path: src/web/frontend/src/i18n/locales/de.ts

import type { Translation } from './en';

export const de: Translation = {
  common: {
    loading: 'Wird geladen...',
    initializing: 'Initialisierung...',
    save: 'Speichern',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    edit: 'Bearbeiten',
    create: 'Erstellen',
    back: 'Zurück',
    confirm: 'Bestätigen',
    search: 'Suchen',
    filter: 'Filtern',
    refresh: 'Aktualisieren',
    updating: 'Aktualisierung...',
    goBack: 'Zurück gehen',
    viewAll: 'Alle anzeigen',
    noData: 'Keine Daten verfügbar',
    of: 'von',
  },
  nav: {
    dashboard: 'Dashboard',
    events: 'Events',
    templates: 'Vorlagen',
    settings: 'Einstellungen',
    calendar: 'Kalender',
    compositions: 'Zusammenstellungen',
  },
  dashboard: {
    title: 'Dashboard',
    subtitle: 'Übersicht über Events und Statistiken Ihres Servers',
    loadingDashboard: 'Dashboard wird geladen...',
    createEvent: 'Event erstellen',
    quickAccess: 'Schnellzugriff',
    stats: {
      totalEvents: 'Gesamt Events',
      activeEvents: 'Aktive Events',
      templates: 'Vorlagen',
      totalParticipants: 'Gesamt Teilnehmer',
    },
    quickActions: {
      viewAllEvents: 'Alle Events anzeigen',
      viewAllEventsDesc: 'Verwalten Sie Ihre Server-Events',
      eventCalendar: 'Event-Kalender',
      eventCalendarDesc: 'Events im Kalenderformat anzeigen',
    },
  },
  events: {
    title: 'Events',
    event: 'Event',
    events: 'Events',
    showing: 'Anzeigen',
    eventsFound: 'Events gefunden',
    loadingEvents: 'Events werden geladen...',
    createEvent: 'Event erstellen',
    searchPlaceholder: 'Events nach Titel oder Beschreibung durchsuchen...',
    filters: {
      all: 'Alle Events',
      scheduled: 'Geplant',
      active: 'Aktiv',
      completed: 'Abgeschlossen',
      cancelled: 'Abgesagt',
      dateRange: 'Datumsbereich',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      showFilters: 'Filter anzeigen',
      hideFilters: 'Filter ausblenden',
      clearFilters: 'Filter löschen',
    },
    status: {
      scheduled: 'Geplant',
      active: 'Aktiv',
      completed: 'Abgeschlossen',
      cancelled: 'Abgesagt',
    },
    noEvents: 'Keine Events gefunden',
    noEventsDesc: 'Erstellen Sie Ihr erstes Event, um zu beginnen',
    viewDetails: 'Details anzeigen',
    participants: 'Teilnehmer',
    startTime: 'Startzeit',
  },
  eventDetails: {
    title: 'Event-Details',
    loading: 'Event wird geladen...',
    loadingDetails: 'Eventdetails werden geladen...',
    backToEvents: 'Zurück zu Events',
    backButton: 'Zurück zu Events',
    edit: 'Event bearbeiten',
    composition: 'Zusammenstellung',
    fullEdit: 'Vollständige Bearbeitung',
    participants: 'Teilnehmer',
    description: 'Beschreibung',
    startTime: 'Startzeit',
    maxParticipants: 'Max. Teilnehmer',
    unlimited: 'Unbegrenzt',
    status: 'Status',
    template: 'Vorlage',
    noDescription: 'Keine Beschreibung vorhanden',
    noDescriptionPlaceholder: 'Keine Beschreibung (klicken Sie zum Hinzufügen)',
    notFound: 'Event nicht gefunden',
    notFoundDesc: 'Dieses Event wurde möglicherweise gelöscht',
    deleteConfirm: 'Sind Sie sicher, dass Sie dieses Event löschen möchten?',
    clickToEdit: 'Zum Bearbeiten klicken',
    saving: 'Speichern...',
    save: 'Speichern',
    cancel: 'Abbrechen',
    failedToUpdate: 'Aktualisierung fehlgeschlagen',
    failedToDelete: 'Löschen fehlgeschlagen',
    createdBy: 'Erstellt von',
    createdAt: 'Erstellt am',
    statistics: 'Statistiken',
  },
  createEvent: {
    title: 'Neues Event erstellen',
    titleEdit: 'Event bearbeiten',
    subtitle: 'Füllen Sie die Details aus, um ein neues Event zu erstellen',
    subtitleEdit: 'Event-Details aktualisieren',
    backToEvents: 'Zurück zu Events',
    save: 'Event erstellen',
    saveEdit: 'Event aktualisieren',
    loadFailed: 'Kanäle und Vorlagen konnten nicht geladen werden',
    cancel: 'Abbrechen',
    createButton: 'Event erstellen',
    updateButton: 'Event aktualisieren',
    creating: 'Wird erstellt...',
    updating: 'Wird aktualisiert...',
    fields: {
      title: 'Event-Titel',
      titlePlaceholder: 'Wöchentlicher Raid-Abend',
      description: 'Beschreibung',
      descriptionPlaceholder: 'Begleiten Sie uns zu unserem wöchentlichen Raid-Abend...',
      startTime: 'Startzeit',
      maxParticipants: 'Max. Teilnehmer',
      maxParticipantsHint: '(0 = unbegrenzt)',
      maxParticipantsPlaceholder: '25',
      channel: 'Kanal',
      channelRequired: 'erforderlich',
      loadingChannels: 'Kanäle werden geladen...',
      selectChannel: 'Wählen Sie einen Kanal',
      noChannels: 'Keine Textkanäle auf diesem Server gefunden. Bitte überprüfen Sie die Bot-Berechtigungen.',
      channelHint: 'Die Event-Nachricht wird in diesem Kanal veröffentlicht',
      template: 'Vorlage (Optional)',
      loadingTemplates: 'Vorlagen werden geladen...',
      noTemplate: 'Keine Vorlage',
      templateHint: 'Rollen, Limits und Konfiguration aus einer Vorlage übernehmen',
    },
  },
  createTemplate: {
    title: 'Neue Vorlage erstellen',
    titleEdit: 'Vorlage bearbeiten',
    subtitle: 'Erstellen Sie eine wiederverwendbare Vorlage für Events',
    subtitleEdit: 'Aktualisieren Sie Ihre Event-Vorlageneinstellungen',
    backToTemplates: 'Zurück zu Vorlagen',
    save: 'Vorlage erstellen',
    saveEdit: 'Vorlage aktualisieren',
    loadFailed: 'Vorlage konnte nicht geladen werden',
    cancel: 'Abbrechen',
    createButton: 'Vorlage erstellen',
    updateButton: 'Vorlage aktualisieren',
    creating: 'Wird erstellt...',
    updating: 'Wird aktualisiert...',
    fields: {
      name: 'Vorlagenname',
      namePlaceholder: 'Mythisch+ Run',
      maxParticipants: 'Max. Teilnehmer',
      maxParticipantsHint: '(0 = unbegrenzt)',
      maxParticipantsPlaceholder: '5',
      description: 'Beschreibung',
      descriptionPlaceholder: 'Standard Mythisch+ Dungeon-Run-Vorlage',
      allowedRoles: 'Erlaubte Rollen',
      allowedRolesPlaceholder: 'Tank, Heiler, DPS',
      allowedRolesHint: 'Kommagetrennte Liste von Rollen',
      roleLimits: 'Rollenlimits (Optional)',
      roleLimitsPlaceholder: 'Tank:2, Heiler:5, DPS:18',
      roleLimitsHint: 'Format: Rolle:Limit, Rolle:Limit (kommagetrennte Paare)',
      emojiMapping: 'Emoji-Zuordnung',
      emojiMappingPlaceholder: 'Tank:🛡️, Heiler:❤️, DPS:⚔️',
      emojiMappingHint: 'Format: Rolle:Emoji, Rolle:Emoji (kommagetrennte Paare)',
      imageUrl: 'Bild-URL (Optional)',
      imageUrlPlaceholder: 'https://example.com/image.png',
      imageUrlHint: 'Fügen Sie ein Banner-Bild zu Event-Embeds hinzu, die aus dieser Vorlage erstellt wurden',
    },
    help: {
      title: 'Vorlagen-Tipps',
      tip1: 'Vorlagen können für mehrere Events wiederverwendet werden',
      tip2: 'Erlaubte Rollen helfen Teilnehmern, ihre Position zu wählen',
      tip3: 'Emoji-Zuordnung macht Anmeldungen visueller und ansprechender',
      tip4: 'Legen Sie max. Teilnehmer fest, um Gruppengrößenbeschränkungen durchzusetzen',
    },
    presets: {
      title: 'Schnellvorlagen',
    },
  },
  templates: {
    title: 'Event-Vorlagen',
    templatesConfigured: 'Vorlagen konfiguriert',
    loadingTemplates: 'Vorlagen werden geladen...',
    createTemplate: 'Vorlage erstellen',
    noTemplates: 'Keine Vorlagen gefunden',
    noTemplatesDesc: 'Erstellen Sie Vorlagen für wiederkehrende Events',
    deleteConfirm: 'Möchten Sie diese Vorlage wirklich löschen?',
    deleteFailed: 'Vorlage konnte nicht gelöscht werden',
    created: 'Erstellt',
    roles: 'Rollen',
    roleLimit: 'Rollenlimit',
    rolesConfigured: 'Rollen konfiguriert',
    maxParticipants: 'Max. Teilnehmer',
    edit: 'Bearbeiten',
    delete: 'Löschen',
  },
  settings: {
    title: 'Einstellungen',
    subtitle: 'Konfigurieren Sie Ihre Server-Einstellungen',
    loadingSettings: 'Einstellungen werden geladen...',
    saveSettings: 'Einstellungen speichern',
    savingSettings: 'Wird gespeichert...',
    saveSuccess: '✅ Einstellungen erfolgreich gespeichert!',
    saveFailed: '❌ Einstellungen konnten nicht gespeichert werden',
    selectAChannel: 'Kanal auswählen...',
    archiveAfterHours: 'Archivieren nach (Stunden)',
    add: 'Hinzufügen',
    clearAllRoles: 'Alle Rollen löschen',
    moduleAccessPermissions: 'Modulzugriffsberechtigungen',
    managerHasFullAccess: 'Die Manager-Rolle hat unabhängig von diesen Einstellungen vollen Zugriff auf alle Module',
    eventsModule: '📅 Events',
    compositionsModule: '⚔️ Zusammenstellungen',
    templatesModule: '📋 Vorlagen',
    settingsModule: '⚙️ Einstellungen',
    sections: {
      languageTimezone: 'Sprache & Zeitzone',
      managerAccess: 'Manager-Zugriff',
      automation: 'Automatisierung',
      channels: 'Kanäle',
      statistics: 'Statistiken',
      participantNotes: 'Teilnehmernotizen',
    },
    language: {
      title: 'Sprache',
      description: 'Wählen Sie Ihre bevorzugte Sprache',
      en: 'English',
      ru: 'Русский',
      de: 'Deutsch',
    },
    timezone: {
      title: 'Zeitzone',
      description: 'Zeitzone Ihres Servers festlegen',
      selectTimezone: 'Wählen Sie die Zeitzone Ihres Servers. Events werden in dieser Zeitzone angezeigt.',
      currentTime: 'Aktuelle Zeit',
    },
    managerRoles: {
      title: 'Manager-Rollen',
      description: 'Wählen Sie Rollen aus, die Events und Einstellungen verwalten können',
      noRoles: 'Keine Rollen ausgewählt',
      permissions: 'Berechtigungen',
      canAccessEvents: 'Zugriff auf Events',
      canAccessCompositions: 'Zugriff auf Zusammenstellungen',
      canAccessTemplates: 'Zugriff auf Vorlagen',
      canAccessSettings: 'Zugriff auf Einstellungen',
      managerRole: 'Manager-Rolle',
      noManagerRole: '-- Keine Manager-Rolle --',
      dashboardAccessRoles: 'Dashboard-Zugriffsrollen',
      dashboardAccessHint: 'Wählen Sie Rollen aus, die auf das Dashboard zugreifen können. Wenn leer, nur Manager haben Zugriff.',
      currentRoles: 'Aktuelle Rollen:',
      selectRoleToAdd: 'Rolle zum Hinzufügen auswählen',
      addRole: 'Hinzufügen',
      allPages: 'Alle Seiten',
    },
    automation: {
      autoArchive: 'Abgeschlossene Events automatisch archivieren',
      autoArchiveDesc: 'Events nach Abschluss automatisch archivieren',
      enableReminders: 'Event-Erinnerungen aktivieren',
      enableRemindersDesc: 'Erinnerungen vor Event-Beginn senden',
      reminderTime: 'Erinnerungszeit (Stunden vor Event)',
      reminderIntervals: 'Erinnerungsintervalle',
      reminderIntervalsHint: 'Stunden vor Event durch Komma getrennt',
      reminderIntervalsPlaceholder: '24, 1',
      dmReminders: 'DM-Erinnerungen',
      dmRemindersDesc: 'Direktnachrichten an bestätigte Teilnehmer vor Events senden',
      logRetention: 'Log-Aufbewahrung (Tage)',
      logRetentionHint: 'Wie lange Audit-Logs aufbewahrt werden (0 = immer)',
      logRetentionPlaceholder: '30',
    },
    channels: {
      defaultChannel: 'Standard-Event-Kanal',
      defaultChannelDesc: 'Standardkanal für Event-Posts',
      logChannel: 'Log-Kanal',
      loggingChannel: 'Log-Kanal',
      logChannelDesc: 'Kanal für Audit-Logs',
      loggingChannelHint: 'Kanal für Audit-Logs',
      archiveChannel: 'Archiv-Kanal',
      archiveChannelDesc: 'Kanal für archivierte Events',
      archiveChannelHint: 'Kanal für archivierte Events',
      selectChannel: 'Kanal auswählen',
      selectChannelOption: '-- Kanal auswählen --',
      archiveAfterHours: 'Archivieren nach (Stunden)',
      approvalChannels: 'Genehmigungs-Kanäle',
      approvalChannelsHint: 'Kanäle, die Manager-Genehmigung erfordern',
      threadChannels: 'Thread-Kanäle',
      threadChannelsHint: 'Kanäle, in denen Event-Threads erstellt werden',
    },
    statistics: {
      enableStats: 'Statistiken aktivieren',
      enableStatsDesc: 'Server-Statistiken verfolgen und anzeigen',
      enableStatsTracking: 'Statistikverfolgung aktivieren',
      enableTracking: 'Statistikverfolgung aktivieren',
      statsChannel: 'Statistik-Kanal',
      selectChannel: '-- Kanal auswählen --',
      updateInterval: 'Aktualisierungsintervall',
      hourly: 'Stündlich',
      daily: 'Täglich',
      weekly: 'Wöchentlich',
      monthly: 'Monatlich',
      autoRoleTop10: 'Auto-Rolle für Top 10',
      top10Role: 'Top 10 Rolle',
      minEventsRequired: 'Min. erforderliche Events',
    },
    participantNotes: {
      enableNotes: 'Teilnehmernotizen aktivieren',
      enableNotesDesc: 'Managern erlauben, Notizen zu Teilnehmern hinzuzufügen',
      notesChannels: 'Notizen-Kanäle',
      notesChannelsDesc: 'Kanäle, in denen Notizen sichtbar sind',
      participantNotes: 'Teilnehmernotizen',
      allowParticipantNotes: 'Teilnehmernotizen erlauben',
      allowNotes: 'Teilnehmernotizen erlauben',
      showViewOnlineButton: '\'Online ansehen\'-Schaltfläche anzeigen',
      showViewOnline: '\'Online ansehen\'-Schaltfläche anzeigen',
      showViewOnlineButtonHint: 'Link zur öffentlichen Event-Ansicht in Discord-Nachrichten anzeigen',
      showViewOnlineDesc: 'Link zur öffentlichen Event-Ansicht in Discord-Nachrichten anzeigen',
      maxNoteLength: 'Max. Notizlänge',
      maxNoteLengthHint: 'Maximal erlaubte Zeichen in Teilnehmernotizen (Standard: 30)',
      maxNoteLengthPlaceholder: '500',
      noteChannels: 'Notizen-Kanäle',
      noteChannelsHint: 'Kanäle, in denen Teilnehmer Notizen zu ihren Anmeldungen hinzufügen können. Wenn leer, sind Notizen in allen Kanälen erlaubt.',
      currentChannels: 'Aktuelle Kanäle:',
      selectChannelToAdd: 'Kanal zum Hinzufügen auswählen',
      addChannel: 'Hinzufügen',
    },
  },
  calendar: {
    title: 'Event-Kalender',
    loading: 'Kalender wird geladen...',
    today: 'Heute',
    month: 'Monat',
    week: 'Woche',
    day: 'Tag',
    noEvents: 'Keine Events für diesen Zeitraum',
  },
  compositions: {
    title: 'Zusammenstellungen',
    loading: 'Zusammenstellungen werden geladen...',
    eventsWithPlans: 'Events mit Raid-Plänen',
    noCompositions: 'Noch keine Zusammenstellungen',
    noCompositionsDesc: 'Erstellen Sie eine Zusammenstellung für ein bevorstehendes Event',
    viewComposition: 'Zusammenstellung anzeigen',
    viewEvents: 'Events anzeigen',
    slotsFilled: 'Plätze belegt',
    groups: 'Gruppe(n)',
  },
  compositionTool: {
    title: 'Zusammenstellungs-Tool',
    loading: 'Wird geladen...',
    saveComposition: 'Zusammenstellung speichern',
    groups: 'Gruppen',
    bench: 'Bank',
    unassigned: 'Nicht zugewiesen',
    backToEvent: 'Zurück zum Event',
    saving: 'Wird gespeichert...',
    viewPublicPage: 'Öffentliche Seite ansehen',
    profiles: 'Profile',
    searchParticipants: 'Teilnehmer suchen...',
    noMatches: 'Keine Übereinstimmungen',
    allAssigned: 'Alle zugewiesen',
    strategyDescription: 'Strategiebeschreibung',
    editStrategy: 'Bearbeiten',
    editStrategyDescription: 'Strategiebeschreibung bearbeiten',
    addStrategy: 'Strategie hinzufügen',
    saveStrategy: 'Strategie speichern',
    cancel: 'Abbrechen',
    edit: 'Bearbeiten',
    strategyPlaceholder: 'Beschreiben Sie Ihre Raid-Strategie, Boss-Mechaniken, Spielerzuweisungen usw...',
    charactersCount: 'Zeichen',
    characters: 'Zeichen',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
    noStrategyYet: 'Noch keine Strategiebeschreibung. Klicken Sie auf "Strategie hinzufügen", um eine hinzuzufügen.',
    strategyPosition: 'Strategie',
    strategyAbove: 'oben',
    strategyBelow: 'unten',
    toggleStrategyPosition: 'Strategieposition umschalten',
    dragging: 'Wird gezogen...',
    deleteGroupConfirm: 'Diese Gruppe löschen?',
    addGroup: '+ Gruppe hinzufügen',
    clickToEditTitle: 'Zum Bearbeiten klicken',
    defaultTitle: 'Raid-Zusammenstellung - Event',
    profilesModal: {
      title: 'Zusammenstellungsprofile',
      description: 'Speichern Sie Ihre aktuelle Zusammenstellung in einem Profil und laden Sie sie später. Die Profile werden gespeichert, sodass auch andere Manager dieses Servers sie verwenden können.',
      saveProfile: 'Profil speichern',
      loadProfile: 'Profil laden',
      profileName: 'Profilname',
      profileNamePlaceholder: 'Profilnamen eingeben...',
      profileDescription: 'Beschreibung (optional)',
      profileDescriptionPlaceholder: 'Beschreibung hinzufügen...',
      loadingPresets: 'Profile werden geladen...',
      noPresets: 'Keine Profile gefunden. Speichern Sie zuerst eines!',
      hasStrategyNotes: 'Hat Strategienotizen',
      groupsCount: 'Gruppen',
      positionsCount: 'Positionen',
      deleteConfirm: 'Dieses Profil löschen?',
    },
  },
  publicEvent: {
    loading: 'Event wird geladen...',
    notFound: 'Event nicht gefunden',
    notFoundDesc: 'Dieses Event existiert möglicherweise nicht oder ist nicht öffentlich zugänglich',
    description: 'Beschreibung',
    participants: 'Teilnehmer',
    confirmed: 'Bestätigt',
    pending: 'Ausstehende Genehmigung',
    waitlist: 'Warteliste / Bank',
    noParticipants: 'Noch keine Teilnehmer',
    viewRaidPlan: 'Raid-Plan ansehen',
    raidPlanAvailable: 'Für dieses Event ist ein Raid-Zusammensetzungsplan verfügbar',
  },
  nativeEvents: {
    title: 'Native Discord Events',
    createEvents: 'Discord Events erstellen',
    createEventsDescription: 'Automatisch native Discord-geplante Events für Ihre Bot-Events mit dynamischen Teilnehmer-Updates erstellen',
    benefitsTitle: 'Vorteile nativer Discord-Events:',
    benefit1: 'Events erscheinen im Discord-Server-Kalender',
    benefit2: 'Mitglieder können als "Interessiert" markieren',
    benefit3: 'Automatische Teilnehmerzahl-Updates',
    benefit4: 'Events werden automatisch abgeschlossen oder gelöscht',
  },
  landing: {
    hero: {
      title: 'RaidBot',
      subtitle: 'Event-Management der nächsten Generation für Discord',
      description: 'Leistungsstark, flexibel und intuitiv. Organisieren Sie Raids, Events und Aktivitäten mit erweiterter Planung, Vorlagen und Teilnehmerverwaltung.',
      loginWithDiscord: 'Mit Discord anmelden',
      adminLogin: 'Admin-Anmeldung mit Passwort',
      hidePasswordLogin: 'Passwort-Anmeldung ausblenden',
      passwordAuthInfo: 'Passwort-Authentifizierung bietet nur Zugriff auf das Admin-Panel',
      username: 'Benutzername',
      password: 'Passwort',
      loggingIn: 'Anmeldung läuft...',
      login: 'Anmelden',
      welcomeBack: 'Willkommen zurück',
      loggedInAs: 'Angemeldet als',
      goToDashboard: 'Zum Dashboard',
      goToAdminPanel: 'Zum Admin-Panel',
      logout: 'Abmelden',
    },
    features: {
      title: 'Leistungsstarke Funktionen',
      subtitle: 'Alles, was Sie brauchen, um Discord-Events in großem Maßstab zu organisieren und zu verwalten',
      eventScheduling: {
        title: 'Event-Planung',
        description: 'Erstellen Sie Events mit benutzerdefinierten Daten, Zeiten, Zeitzonenunterstützung und Teilnehmerlimits. Kalenderansicht inklusive!',
      },
      smartParticipants: {
        title: 'Intelligente Teilnehmer',
        description: 'Rollenbasierte Anmeldung, Wartelisten, Ersatzbank und Teilnehmernotizen für bessere Organisation',
      },
      eventTemplates: {
        title: 'Event-Vorlagen',
        description: 'Sparen Sie Zeit mit wiederverwendbaren Vorlagen einschließlich Rollen, Limits und benutzerdefinierten Konfigurationen',
      },
      reminders: {
        title: 'Erinnerungen & DMs',
        description: 'Automatische Erinnerungen vor Events, DM-Benachrichtigungen und konfigurierbare Erinnerungsintervalle',
      },
      statistics: {
        title: 'Statistiken & Bestenlisten',
        description: 'Verfolgen Sie Teilnahme, Abwesenheiten, Auto-Rollen für Top-Teilnehmer und detaillierte Analysen',
      },
      voiceChannels: {
        title: 'Auto-Sprachkanäle',
        description: 'Automatische Erstellung und Bereinigung von Sprachkanälen mit Teilnehmerbeschränkungen',
      },
      threads: {
        title: 'Thread-Verwaltung',
        description: 'Automatisches Erstellen von Event-Threads für Diskussionen mit Bereinigungs- und Archivierungsoptionen',
      },
      multiLanguage: {
        title: 'Mehrsprachig',
        description: 'Unterstützung für Englisch und Russisch mit einfacher Erweiterbarkeit für weitere Sprachen',
      },
      webDashboard: {
        title: 'Web-Dashboard',
        description: 'Voll ausgestattete Web-Oberfläche mit Dark Mode, Kalenderansicht und mobiler Unterstützung',
      },
    },
    footer: {
      copyright: '© 2025 RaidBot',
      madeWith: 'Erstellt mit',
      by: 'von',
      viewOnGithub: 'Auf GitHub ansehen',
    },
  },
  errors: {
    accessDenied: 'Zugriff verweigert',
    accessDeniedEvents: 'Zugriff verweigert: Sie haben keine Berechtigung, Events anzuzeigen.',
    accessDeniedTemplates: 'Zugriff verweigert: Sie haben keine Berechtigung, Vorlagen anzuzeigen.',
    accessDeniedSettings: 'Zugriff verweigert: Sie haben keine Berechtigung, Einstellungen anzuzeigen.',
    loadFailed: 'Laden fehlgeschlagen. Bitte versuchen Sie es erneut.',
    notFound: 'Nicht gefunden',
    goToDashboard: 'Zum Dashboard',
    botNotInGuild: {
      title: 'Bot nicht auf dem Server',
      message: 'Der Bot ist nicht auf diesem Server. Bitte laden Sie den Bot ein, um das Dashboard zu verwenden.',
      inviteButton: 'Bot einladen',
      backButton: 'Zurück zu Servern',
    },
  },
  panelSelect: {
    welcome: 'Willkommen, {username}!',
    subtitle: 'Als Bot-Administrator haben Sie Zugriff auf beide Panels. Wählen Sie, wohin Sie gehen möchten:',
    botAdminPanel: 'Bot-Admin-Panel',
    botAdminDescription: 'Globale Bot-Administration: Verwaltung aller Server, Systemeinstellungen und Statistiken',
    botAdminFeature1: 'Zugriff auf alle Server',
    botAdminFeature2: 'Globale Suche und Analysen',
    botAdminFeature3: 'Systemkonfiguration',
    botAdminFeature4: 'Massenoperationen',
    openBotAdmin: 'Bot-Admin öffnen →',
    guildAdminPanel: 'Gilden-Admin-Panel',
    guildAdminDescription: 'Verwalten Sie Ihre Discord-Server: Events, Vorlagen und serverspezifische Einstellungen',
    guildAdminFeature1: 'Nur Ihre Server',
    guildAdminFeature2: 'Event-Verwaltung',
    guildAdminFeature3: 'Vorlagenerstellung',
    guildAdminFeature4: 'Server-Einstellungen',
    chooseServer: 'Server wählen →',
    backToHome: '← Zurück zur Startseite',
  },
  serverSelect: {
    title: 'Server auswählen',
    subtitle: 'Wählen Sie den zu verwaltenden Server',
    loadingServers: 'Server werden geladen...',
    error: 'Fehler',
    noServersTitle: 'Keine Server verfügbar',
    noServersDescription: 'Es wurden keine Server gefunden, auf denen Sie den Bot verwalten können.',
    makeSure: 'Stellen Sie sicher:',
    requirement1: 'Sie haben MANAGE_GUILD- oder ADMINISTRATOR-Berechtigungen',
    requirement2: 'Der Bot ist auf dem Server eingeladen',
    serversAvailable: '{count} Server verfügbar',
    owner: '👑 Besitzer',
    logout: 'Sind Sie sicher, dass Sie sich abmelden möchten?',
    logoutTitle: '{username} (zum Abmelden klicken)',
    botNotPresent: 'Bot nicht auf diesem Server',
  },
};
